// components/footer-helpers.js: pure rules behind the lobby copyright footer.
//
// Extracted so node:test (which doesn't transform JSX) can cover the footer's
// two rendering rules, the dynamic copyright year and the "hidden in-game"
// visibility gate, without spinning up a DOM. RoomView consumes both.

/**
 * The footer's copyright line, with the CURRENT year computed dynamically so
 * it never drifts stale (never hardcode the year).
 *
 * @returns {string}
 */
export function copyrightText() {
  return `© ${new Date().getFullYear()} euchre.dev`;
}

/**
 * Whether the lobby copyright footer should render. The in-game view is a
 * full-canvas takeover (NetworkedGameView claims the whole viewport), so the
 * footer must stay out of it, it belongs to the lobby/home shell only.
 *
 * @param {boolean} isPlaying, true once the room phase is `in_game`.
 * @returns {boolean}
 */
export function shouldShowLobbyFooter(isPlaying) {
  return !isPlaying;
}
